import imageCarouselView from './imageCarouselComponent.html';
import './imageCarouselComponent.css';

export function imageCarouselComponent() {
	return {
		bindings: {
			choices: '=',
			currIdx: '=',
			onCustom: '&?',
			allowChoosingNone: '<?',
		},
		controllerAs: 'vm',
		controller: imageCarouselComponentCtrl,
		template: imageCarouselView,
	};
}

export class imageCarouselComponentCtrl {
	constructor() {
		'ngInject';
		this.currIdx = 0;
	}

	maxIdx() {
		return this.choices.length + (this.allowChoosingNone ? 0 : -1);
	}

	getSliderTransform() {
		return `translateX(${-235 * this.currIdx}px)`;
	}

	prev() {
		this.currIdx = this.currIdx == 0 ? this.maxIdx() : this.currIdx - 1;
	}

	next() {
		this.currIdx = this.currIdx == this.maxIdx() ? 0 : this.currIdx + 1;
	}
}
